import { Child } from '../../../typings';
import { getFetch } from '../fetch';
import { apiConfig } from '../config';

export function getParentChildren(): Promise<Array<Child>> {
    const { apiGetParentChildren } = apiConfig.getStaticUrls();

    return getFetch(apiGetParentChildren);
}
